import React, { useEffect, useContext, useState } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router';
import { Box, Button, Grid, Paper } from '@material-ui/core';
import ResponsiveLayout from '../../../Layouts/ResponsiveLayout';
import { StateContext, DispatchContext } from '../../../../context/Provider';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import { Document, Page, pdfjs } from 'react-pdf'
import './EbookItem.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const EbookItem = (props) => {

    const { book_id } = useParams();
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { authState } = appState;
    const { globalDispatch } = appDispatch;

    const [ebook, setEbook] = useState([]);
    const [numPages, setNumPages] = useState(0);

    async function fetchEbook() {
        try {
            const response = await axiosConfig.get(`/e-books/${book_id}`);
            const { data } = response.data;
            setEbook(data);

        } catch (e) {
            console.log(e);
        }
    }

    const onDocumentLoadSuccess = (pages) => {
        setNumPages(pages.numPages);
        console.log(pages.numPages);
    }

    useEffect(() => {

        globalDispatch({type: 'setIsLoading', value: true});
        globalDispatch({type: 'setShowTabs', value: false});
        setTimeout(() => globalDispatch({type: 'setIsLoading', value: false}), 500);

        const source = axiosConfig.CancelToken.source();
        fetchEbook();
        return () => {
            source.cancel();
        }

    }, []);

    if (!book_id) {
        return null;
    }

    return (
        <ResponsiveLayout>
            <Grid
                container
                spacing={2}
                justify="center"
            >
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Button
                        disableRipple
                        color="primary"
                        variant="outlined"
                        size="medium"
                        startIcon={<MenuBookIcon />}
                        component={Link}
                        to={`/e-books`}
                    >
                        View E-books
                    </Button>
                </Grid>



                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {/* <Box style={{height: "1000px"}}>
                        <iframe
                            src={`${ebook.file_url || ''}`}
                            width="100%"
                            height="80%"
                            frameBorder="0"
                        />
                    </Box> */}

                    {/* For holaamigos only */}
                    {ebook.length != 0 && authState.user.school_id == 29 &&
                        <Document file={`${process.env.REACT_APP_API_URL}/e-books/${ebook.id}/download`} renderMode="svg" onLoadSuccess={onDocumentLoadSuccess}>
                            {/* <Page pageNumber={1} /> */}
                            {Array.from(new Array(numPages), (el, index) => (
                                <Page scale="2.0" key={`page_${index + 1}`} pageNumber={index + 1} />
                            ))}
                        </Document>
                    }


                    {authState.user.school_id !== 29 && <object data={`${ebook.file_url || ''}#toolbar=0`} type="application/pdf" width="100%" height="800px">
                        <p>It appears you don't have a PDF plugin for this browser.
                        No biggie... you can <a href={`${ebook.file_url || ''}`}>click here to
                        download the PDF file.</a></p>
                    </object>}

                </Grid>
            </Grid>
        </ResponsiveLayout>
    );
}

export default EbookItem;